import React, { Fragment } from "react";
import styled from "styled-components";
import {
  PersonalAgreement1,
  PersonalAgreement2,
  PersonalAgreement3,
  PersonalAgreement4,
  PersonalAgreement5,
  PersonalAgreement6,
  PersonalAgreement7,
  PersonalAgreement8,
  PersonalAgreement9,
} from "./personalInformationAgreements";

const UserBodyBox = styled.div`
  max-width: 1160px;
  margin: 0 auto;
  text-align: center;
  height: auto;
  &:after {
    display: block;
    content: "";
    clear: both;
  }
  ${({ theme }) => theme.media.mobile`
  width: 90%;
  border: 0px;
  border-radius: 0px;
    `}
`;

const UserIndividuallyBox = styled.div`
  float: left;
  padding-top: ${(props) => props.paddingTop || "0px"};
  margin-top: ${(props) => props.marginTop || "0px"};
  width: ${(props) => props.width || "100%"};
  border: ${(props) => props.border || "none"};
  overflow: hidden;
`;
const UserBorderTopBox = styled.div`
  float: left;
  padding-top: ${(props) => props.paddingTop || "0px"};
  margin-top: ${(props) => props.marginTop || "0px"};
  width: ${(props) => props.width || "100%"};
  border-top: ${(props) => props.borderTop || "inherit"};
`;

const UserSpan = styled.span`
  display: block;
  text-align: ${(props) => props.textAlign || "left"};
  padding-top: ${(props) => props.paddingTop || "0px"};
  color: ${(props) => props.color || "#666666"};
  border-bottom: ${(props) => props.border || "none"};
  border-top: ${(props) => props.borderTop || "none"};
  font-size: ${(props) => props.fontSize || "16px"};
  font-weight: ${(props) => props.fontWeight || "inherit"};
  margin: ${(props) => props.margin || "inherit"};
  position: ${(props) => props.position || "static"};
  ${({ theme }) => theme.media.mobile`
  border-bottom: none;
  font-size: 10px;
    `}
`;

export default function PersonalBody() {
  return (
    <Fragment>
      <UserBodyBox>
        <UserIndividuallyBox>
          <UserSpan paddingTop="80px">
            주식회사 랩이오사 서비스 약관(서비스 가맹점용)입니다.
          </UserSpan>
        </UserIndividuallyBox>
        <UserIndividuallyBox paddingTop="96px" width="inherit">
          <div>
            <UserSpan
              color="#1e1e1e"
              fontSize="20px"
              border="1px solid #4d4d4d"
            >
              랩이오사 서비스 약관
            </UserSpan>
          </div>
        </UserIndividuallyBox>
        <UserBorderTopBox
          paddingTop="55px"
          marginTop="80px"
          borderTop="2px solid #1e1e1e"
        >
          <UserIndividuallyBox>
            <PersonalAgreement1></PersonalAgreement1>
            <PersonalAgreement2></PersonalAgreement2>
            <PersonalAgreement3></PersonalAgreement3>
            <PersonalAgreement4></PersonalAgreement4>
            <PersonalAgreement5></PersonalAgreement5>
            <PersonalAgreement6></PersonalAgreement6>
            <PersonalAgreement7></PersonalAgreement7>
            <PersonalAgreement8></PersonalAgreement8>
            <PersonalAgreement9></PersonalAgreement9>
          </UserIndividuallyBox>
        </UserBorderTopBox>
      </UserBodyBox>
    </Fragment>
  );
}
